module.exports = __webpack_public_path__ + "static/media/logo.8a77d668.svg";